import { Link } from "react-router-dom";
import "../Login/Login.scss";
import { useUser } from "../../context/UserContext";
import { usePageTitle } from "../../hooks/usePageTitle";
import { marketingUrl } from "../../lib/marketingUrls";
import logo from "../../assets/oq-logo-1.svg";

const AccessExpiredPage = () => {
  const { logout } = useUser();

  usePageTitle("Access expired");

  return (
    <div className="login-page" id="accessExpiredPage">
      <div className="login-card">
        <a href={marketingUrl("/")} className="login-logo" aria-label="OphthalmologyQ home">
          <img src={logo} alt="OphthalmologyQ" />
        </a>

        <h1 className="login-tagline">Your access has expired</h1>

        <p className="login-footer" style={{ marginTop: 0, marginBottom: 24 }}>
          Your question bank subscription has ended. Sign in still works, but practice questions,
          assignments, and progress features are no longer available until you renew.
        </p>

        <a
          href={marketingUrl("/pricing")}
          className="login-submit"
          style={{ display: "block", textAlign: "center", textDecoration: "none", marginBottom: 12 }}
        >
          View plans
        </a>

        <Link
          to="/dashboard"
          className="login-submit login-submit--secondary"
          style={{ display: "block", textAlign: "center", textDecoration: "none", marginBottom: 12 }}
        >
          Back to dashboard
        </Link>

        <button type="button" className="login-submit login-submit--secondary" onClick={() => logout()}>
          Sign out
        </button>

        <p className="login-footer">
          Need help?{" "}
          <a href={marketingUrl("/contact")}>Contact support</a>
        </p>
      </div>
    </div>
  );
};

export default AccessExpiredPage;
